/* tslint:disable */

declare var Object: any;
export interface ERPpurchaseContractInterface {
  "id"?: number;
}

export class ERPpurchaseContract implements ERPpurchaseContractInterface {
  "id": number;
  constructor(data?: ERPpurchaseContractInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPpurchaseContract`.
   */
  public static getModelName() {
    return "ERPpurchaseContract";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPpurchaseContract for dynamic purposes.
  **/
  public static factory(data: ERPpurchaseContractInterface): ERPpurchaseContract{
    return new ERPpurchaseContract(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPpurchaseContract',
      plural: 'ERPpurchaseContracts',
      path: 'ERPpurchaseContracts',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPpurchaseContract.ts